export const introSectionStyle = {
    position: "relative",
    width: "100%",
    height: "100vh",
    overflow: "hidden",

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundSize: 'cover',
    backgroundPosition: 'center',

    color: '#fff',
    textAlign: 'center',
};

export const videoStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "101%",
    height: "100%",
    objectFit: "cover",
    zIndex: -1,
}


export const titleBoxStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
};


export const titleDetailsBoxStyle = {
    position: 'absolute',
    bottom: '0%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center'
    // width:'100%'
};


export const titleDateStyle = {
    fontSize: {
        xs: '24px',
        sm: '24px',
        md: '24px',
        lg: '24px',
    },
    textAlign: 'center',
    fontFamily: 'Jost-Regular',
};
export const titlePriceStile = {
    fontSize: {
        xs: '24px',
        sm: '24px',
        md: '24px',
        lg: '24px',
    },
    textAlign: 'center',
    fontFamily: 'Jost-Regular',
};
